module.exports = __webpack_public_path__ + "img/about-us.c6f66b67.svg";